import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  FaEdit,
  FaTrashAlt,
  FaPlus,
  FaRegCheckCircle,
  FaRegTimesCircle,
} from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";

import { Button } from "antd";
import styled from "styled-components";
import TableControl from "../../component/table/TableControl";
import FormCreateUser from "./FormCreateUser";
import Actions from "../../redux/actions";
import Service from "../../service/Mgt-user";

const TableExtend = styled(TableControl)``;

const ButtonAddUser = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #05BC9B;
  color : white;
  width: fit-content;
  font-size : 16px;
  height: 40px;
`;

export default function TableMgtUsers(props) {

  const [columns, setColumns] = useState([])
  const users = useSelector((state) => state.mgtUser.users);
  const dispatch = useDispatch();

  useEffect(() => {

    const init = async () => {
      let users = await Service.search();
      if (users) dispatch(Actions.mgtUser.setUsers(users));
    };

    initColumn(props.permission)
    init();
  }, [dispatch, props.permission]);

  const onClickToggleFormMgt = () => {
    dispatch(Actions.popup.toggleVisible(true, "", "", <FormCreateUser permission={props.permission}/>));
  };

  const onDelete = async (id, email) => {
    Swal.fire({
      icon: "question",
      title: `ยืนยันการลบบัญชีผู้ใช้ ${email}`,
      showCancelButton: true,
      confirmButtonText: `ยืนยัน`,
      cancelButtonText: `ยกเลิก`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let result = await Service.delete(id);
        if (result) {
          Swal.fire({
            title: `ลบบัญชีผู้ใช้ ${email} สำเร็จ`,
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500,
          }).then(function () {
            dispatch(Actions.mgtUser.deleteUser(result));
          });
        }
      }
    });
  };

  const buttonCreateUser = (
    <ButtonAddUser
      className="btn-add-data"
      icon={<FaPlus className="icon-add-data" />}
      onClick={onClickToggleFormMgt}
    >
      เพิ่มผู้ใช้งานระบบ
    </ButtonAddUser>
  );
  
  const initColumn = (permission) =>{
    const column = [
      { title: "หน่วยงาน/องค์กร", dataIndex: "org", align: "center", className: "cn allow-search", sorter: (a, b) => (a.org || '-').localeCompare(b.org || '-'),
        render: (_, record) =>{
          return record.org ? record.org : '-'
        }
      },
      { title: "กลุ่ม", dataIndex: "group_name", align: "center", className: "cn allow-search", sorter: (a, b) => a.group_name.localeCompare(b.group_name), },
      { title: "ชื่อ-นามสกุล", dataIndex: "first_name", align: "center", className: "cn allow-search", sorter: (a, b) => a.first_name.localeCompare(b.first_name),
        render: (_, record) => (
          <span>{record.first_name + " " + record.last_name}</span>
      )},
      { title: "อีเมล", dataIndex: "email", align: "center", className: "cn allow-search", sorter: (a, b) => a.email.localeCompare(b.email), },
      { title: "สถานะ", dataIndex: "status", align: "center", className: "cn", sorter: (a, b) => a.status - b.status,
        render: (_, record) => {
          if (record.status == 0 || !record.status)
            return ( <span style={{ color: "#EBEBE4", fontWeight: "bold" }}> ผิดพลาด </span>);
          if (record.status == 1)
            return ( <span style={{ color: "#5FDBA7", fontWeight: "bold" }}>ปกติ</span>);
          if (record.status == 2)
            return ( <span style={{ color: "#C70000", fontWeight: "bold" }}>แบน</span>);
        }},
      {title: "อนุมัติ", dataIndex: "action", align: "center", className: "cell-action", className: "cn", sorter: (a, b) => a.is_approve - b.is_approve,
        render: (_, record) =>
          record.is_approve !== null ? (
            <>
              {record.is_approve === true ? (
                <span> อนุมัติ <br /> {record.approve_date}</span>
              ) : (
                <span> ไม่อนุมัติ <br /> {record.approve_date}</span>
              )}
            </>
          ) : props.permission.indexOf("update") >= 0 ? (
            <>
              <Button className="btn-record-approve" style={{ color: "#5FDBA7" }}
                onClick={async () => {
                  let result = await Service.updateApprove(record.id, true);
                  if (result) { dispatch(Actions.mgtUser.updateUserApprove(result));}
                }}
              >
                <FaRegCheckCircle />
              </Button>
              <Button className="btn-record-reject" style={{ color: "#C70000" }}
                onClick={async () => {
                  let result = await Service.updateApprove(record.id, false);
                  if (result) { dispatch(Actions.mgtUser.updateUserApprove(result));}
                }}
              >
                <FaRegTimesCircle />
              </Button>
            </>
          ) : (
            <>รอดำเนินการ</>
          ),
      }
    ];

    if(permission.indexOf("update") >= 0 || permission.indexOf("delete") >= 0){
      column.push( {
        title: <AiFillSetting />, dataIndex: "action", align: "center", className: "cell-action",
        render: (_, record) => (
          <>
            {props.permission.indexOf("update") >= 0 ? (
              <Button className="btn-edit-data" onClick={() => {
                  dispatch( Actions.popup.toggleVisible( true, "", "", <FormCreateUser permission={props.permission} userId={record.id} />));
                }}
              >
                <FaEdit />
              </Button>
            ) : (
              <></>
            )}
            {props.permission.indexOf("delete") >= 0 ? (
              <Button  className="btn-delete-data" onClick={() => { onDelete(record.id, record.email);}}
              >
                <FaTrashAlt />
              </Button>
            ) : (
              <></>
            )}
          </>
        ),
      })
    }

    setColumns(column)
  }

  return (
    <TableExtend
      className={
        "table-mgt-list-user" + (props.className ? props.className : "")
      }
      topRightButton={
        props.permission.indexOf("create") >= 0 ? buttonCreateUser : ""
      }
      rowKey={"id"}
      data={users}
      columns={columns}
      dataSet={1}
    />
  );
}
